export default __webpack_public_path__ + "static/media/github.320fd1ab.svg";